import { styled } from 'styled-components';

import { ListItemText, Typography } from '@mui/material';

export const PlaceholderText = styled(Typography)`
  font-size: 0.9rem;
  font-weight: 400;
  max-width: 100%;
  text-align: left;
`;

export const ListItemTextOption = styled(ListItemText)`
  text-align: left;
`;
